import React from 'react';
import KbArticle from './kb-article';

export default function renderKbArticle(entry) {
    return <KbArticle entry={entry} />;
}
